import { observable, computed } from "mobx";

export default class ApiCallObservable<T = any> {
  @observable private _isSending: boolean = false;
  @observable private _error: string | undefined = undefined;
  @observable private _response: T | undefined = undefined;

  public reset() {
    this._isSending = false;
    this._error = undefined;
    this._response = undefined;
  }

  public setSending() {
    this._isSending = true;
    this._error = undefined;
    this._response = undefined;
  }

  public setError(error: string) {
    this._isSending = false;
    this._response = undefined;
    this._error = error;
  }

  public setSuccessfulResponse(data: T) {
    this._isSending = false;
    this._response = data;
    this._error = undefined;
  }

  @computed
  get isSending() {
    return this._isSending;
  }

  @computed
  get errorMessage() {
    return this._error;
  }

  @computed
  get error() {
    return Boolean(this._error);
  }

  @computed
  get success() {
    return Boolean(this._response);
  }

  @computed
  get response() {
    return this._response;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Admin/state/mobx/common/ApiCallObservable.ts